export default {"src":"/_next/static/media/data-insights.8fcfa4e3.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};